import { DateTime } from 'luxon';
import { months, days, getDayNameFromDate, daysOfMonth } from '../utils/CustomDateTime';

const date = DateTime.now().setZone('America/Mexico_City').setLocale('es');

export default (
    component_name,
    options = {
        multiple: false,
        initialValues: undefined,
        selectedMonth: undefined,
    }
) => ({
    selectedMonth: null,
    selectedMonthIndex: -1,
    selectedDates: [],
    maxDaysSelectedMonth: 0,
    selectedYear: null,

    toggleSelectAll: false,
    showMonths: false,
    isSubmitted: false,
    isDisabled: false,

    init() {
        const month        = date.toFormat('LLLL');
        const monthIndex   = months.findIndex(m => m === month);
        const firstDayName = getDayNameFromDate(+date.toFormat('yyyy'), +date.toFormat('L'), 1);
        const dayIndex     = days.findIndex(d => d === firstDayName);
        const daysMonth    = daysOfMonth(+date.toFormat('yyyy'), +date.toFormat('L'));

        this.selectedMonth = month;
        this.selectedMonthIndex = monthIndex;
        this.firstDayIndex = dayIndex;
        this.maxDaysSelectedMonth = daysMonth;
        this.selectedYear = +date.toFormat('yyyy');

        this.$watch('selectedDates', (value, old) => {
            if (options.multiple && options.multiple === true) {
                const dates = this.selectedDates.map(date => {
                    const [day, month, year] = date.split('-');
                    return DateTime.local(+year, +month, +day).toFormat('yyyy-LL-dd');
                });
                this.$dispatch(`${component_name}-change`, [dates, this.isValid]);
                return;
            }
            const [day, month, year] = value.split('-');
            this.$dispatch(`${component_name}-change`, [DateTime.local(year, month, day).toFormat('yyyy-LL-dd'), this.isValid]);
        });

        if (options.initialValues !== undefined && options.initialValues !== null) {
            this.selectedDates = options.multiple && options.multiple === true ? [...options.initialValues] : options.initialValues;
        } else {
            this.selectedDates = options.multiple && options.multiple === true ? [] : undefined;
        }
    },

    setMonthProperties(){
        const firstDayName = getDayNameFromDate(this.selectedYear, this.selectedMonthIndex + 1, 1);
        const dayIndex = days.findIndex(d => d === firstDayName);
        const daysMonth = daysOfMonth(this.selectedYear, this.selectedMonthIndex + 1);

        this.firstDayIndex = dayIndex;
        this.maxDaysSelectedMonth = daysMonth;
        this.selectedMonth = months[this.selectedMonthIndex];

        this.selectedDates = [...this.selectedDates];
    },

    cleanSelectedDays() {
        this.selectedDates = [];
    },

    nextMonth() {
        this.selectedMonthIndex++;
        if (this.selectedMonthIndex > 11) {
            this.selectedMonthIndex = 0;
            this.selectedYear++;
        }
        this.setMonthProperties();
    },

    prevMonth() {
        this.selectedMonthIndex--;
        if (this.selectedMonthIndex < 0) {
            this.selectedMonthIndex = 11;
            this.selectedYear--;
        }
        this.setMonthProperties();
    },

    setSelectedMonth(month) {
        this.showMonths = false;
        this.selectedMonthIndex = months.findIndex(m => m === month.nombre.toLowerCase());
        this.setMonthProperties();

        // Eliminamos los dias seleccionados que no existen en el mes seleccionado
        /* this.selectedDates = options.multiple
            ? this.selectedDates.filter(day => day < month.num_dias)
            : this.selectedDates > month.num_dias ? undefined : this.selectedDates; */
    },

    get isValid() {
        if (options.required === true) {
            return options.multiple
                ? this.selectedDates.length > 0
                : this.selectedDates !== undefined;
        }
        return true;
    }
})
